import BaseEntity from "../base/BaseEntity";

let Status = {
	OK: "OK",
	ERROR: "ERROR"
}


//id=>1 超级管理员 id=>2 注册用户 id=>3 游客
export default function UserRole(id = 3) {

	//extend BaseEntity's Attributes.
	BaseEntity.call(this, arguments);


	this.id = id;
	this.name = null;
	this.description = null;

}


//extend BaseEntity
UserRole.prototype = new BaseEntity();
UserRole.prototype.constructor = UserRole;
UserRole.prototype.TAG = "userRole";
UserRole.prototype.TAGS = "userRoles";
UserRole.prototype.URL_PAGE = "/user/role/page";
UserRole.prototype.URL_DETAIL = "/user/role/detail/{id}";
UserRole.prototype.URL_CREATE = "/user/role/create";
UserRole.prototype.URL_EDIT = "/user/role/edit";
UserRole.prototype.URL_DEL = "/user/role/del/{id}";

UserRole.prototype.ROLE_SUPER_ADMINISTRATOR = 1;
UserRole.prototype.ROLE_USER = 2;
UserRole.prototype.ROLE_GUEST = 3;

UserRole.prototype.Status = Status;

//We use this method to get the full js Object.
UserRole.prototype.render = function (obj) {
	BaseEntity.prototype.render.call(this, obj);

}

UserRole.prototype.getForm = function () {

	let form = {
		name: this.name,
		description: this.description
	};
	if (this.id) {
		form.id = this.id;
	}
	return form;
}


UserRole.prototype.validate = function () {

	if (!this.name) {
		this.errorMessage = "标题必填！";
		return false;
	}

	return true;
}






// WEBPACK FOOTER //
// ./src/common/model/user/UserRole.js